import { EvtHeader, EvtSectionHeader } from "components/header";
import { JobDashboardStatsSection } from "@/modules/work/jobs/components/dashboard-stats-section";
import HeaderPortal from "components/portal/header-portal";
import EditItemButton from "components/buttons/edit";
import { EvtCoordinatorCard } from "components/coordinator/display-card";
import { PermissionControlledInput } from "permissions/components/input";
import React from "react";
import { useJob } from "@/modules/work/jobs/context";
import { useParams } from "react-router-dom";
import MilestoneCreationBanner from "./components/milestone-banner";
import JobTagsSection from "./components/tags";
import { DashboardInfoField } from "components/dashboard/info-field";
import { DisplayDate } from "components/display/date";

export default function JobDashboard() {
  const { jobId } = useParams();

  const { type, status, start_date, end_date } = useJob();

  return (
    <div className="flex-1 pb-5">
      {((type === "bucket" || type === "hourly") && status === "in_progress") &&
        <div className="mt-3.5">
          <MilestoneCreationBanner />
        </div>
      }
      <EvtHeader title="Dashboard" />
      <JobTagsSection />
      <section>
        <div className="grid grid-cols-4 px-4 gap-4 md:px-6 mt-2.5 ">
          <DashboardInfoField label="Start Date">
            <DisplayDate value={start_date} />
          </DashboardInfoField>
          <DashboardInfoField label="End Date">
            <DisplayDate value={end_date} />
          </DashboardInfoField>
        </div>
      </section>
      <JobDashboardStatsSection />

      <section className="mt-3.5">
        <EvtSectionHeader title="Coordinator" />
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 px-4 gap-4 md:px-6 mt-2.5">
          <EvtCoordinatorCard
            collection="jobs"
            id={jobId}
            role="Job Coordinator"
          />
        </div>
      </section>
      <HeaderPortal>
        <PermissionControlledInput
          rule="update:PC,JC,SC,AM"
          collection="jobs"
        >
          <EditItemButton variant="ghost" />
        </PermissionControlledInput>
      </HeaderPortal>
    </div>
  );
}
